import type { Stripe } from "@stripe/stripe-js";
import { loadStripe } from "@stripe/stripe-js/pure";
import { getStripePublicKey } from "./getUrlPrefix";

type StripeLoad =
  | { status: "loading" }
  | { status: "ready"; stripe: Stripe | null }
  | { status: "failed"; error: unknown };

let load: StripeLoad = { status: "loading" };
let started = false;
const subscribers = new Set<() => void>();

function publish(next: StripeLoad) {
  load = next;
  for (const notify of subscribers) {
    notify();
  }
}

function startLoading() {
  if (started) {
    return;
  }
  started = true;
  // Imported from `@stripe/stripe-js/pure` because the default entry point injects the js.stripe.com
  // script as a side effect of being imported, which would defeat loading it lazily.
  loadStripe(getStripePublicKey()).then(
    (stripe) => {
      publish({ status: "ready", stripe });
    },
    (error: unknown) => {
      publish({ status: "failed", error });
    },
  );
}

export function subscribeToStripe(onStoreChange: () => void) {
  startLoading();
  subscribers.add(onStoreChange);
  return () => {
    subscribers.delete(onStoreChange);
  };
}

export function getStripeLoad() {
  return load;
}
